// extracted by mini-css-extract-plugin
export default {"custom-result":"styles_custom-result__U6nIR"};